import { variants } from "components/AnimatedRoutes";
import { getDownloadURL, listAll, ref } from "firebase/storage";
import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { Carousel, Container } from "react-bootstrap";
import { storage } from "services";
import "./EdDepInfo.scss";


// import { ReactEmbeddedGoogleCalendar } from "react-embedded-google-calendar";

// a constant that store the calendar url link
// REMOVE THIS
const myCalSrc =
  "https://calendar.google.com/calendar/embed?src=cadence.tennant%40gmail.com&ctz=America%2FNew_York";

export function EdDepInfo(): JSX.Element {
  const [photos, setPhotos] = useState<string[]>([]);
  const [staticPhotos, setStaticPhotos] = useState<string[]>([]);
  const [allSlides, setAllSlides] = useState<string[]>([]);

  /**
   * Fetching all the photos or slides from firebase storage
   * Store all of the url of each photos into the photos array
   */
  useEffect(() => {
    const getAllPhotos = () => {
      const edDeptInfoRef = ref(storage, "edDeptInfoSlide/");
      listAll(edDeptInfoRef)
        .then(function (result) {
          result.items.forEach(function (imageRef) {
            getDownloadURL(imageRef)
              .then(function (url) {
                setPhotos([]);
                photos.push(url);
                setPhotos(photos);
              })
              .catch(function (error) {
                alert("Something went here! please try again");
              });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    };
    getAllPhotos();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    function getAllStaticPhotos() {
      const staticInfoSlidesRef = ref(storage, "staticInfoSlides/");
      listAll(staticInfoSlidesRef)
        .then(function (result) {
          result.items.forEach(function (imageRef) {
            getDownloadURL(imageRef)
              .then(function (url) {
                setStaticPhotos([]);
                staticPhotos.push(url);
                setStaticPhotos(staticPhotos);
              })
              .catch(function (error) {
                alert("Something went here! please try again");
              });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    }
    getAllStaticPhotos();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const fetchSlides = async () => {
      const allPaths = ["edDeptInfoSlide/", "staticInfoSlides/", "departmentUpdateSlides/"];
      const tempSlides: string[] = [];
  
      try {
        const allPromises = allPaths.map(async path => {
          const pathRef = ref(storage, path);
          const result = await listAll(pathRef);
          const urls = await Promise.all(
            result.items.map(item => getDownloadURL(item)),
          );
          return urls;
        });
  
        const slidesArrays = await Promise.all(allPromises);
        const flatSlides = slidesArrays.flat(); // combine all URL arrays into one
        setAllSlides(flatSlides);
      } catch (error) {
        console.error("Error loading slides:", error);
      }
    };
  
    fetchSlides();
  }, []);
  

  return (
    <motion.div
      variants={variants}
      initial="enter"
      animate="center"
      exit="exit"
      transition={{
        x: { bounce: 0, duration: 0.5, type: "spring" },
      }}
    >
      <Container fluid className="edpage-container">
        <div className="carousel-wrapper">
          <div className="carousel-logo">Department Info</div>
          <div className="carousel">
            <Carousel>
              {allSlides.map(slide => (
                <Carousel.Item key={slide} interval={10000}>
                  <img className="d-block w-100" src={slide || ""} alt="Slide" loading="lazy" />
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
        </div>
      </Container>
    </motion.div>
  );
}
